/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_EmailsInputs */

const en_nav_emails = /** @type {(inputs: Nav_EmailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emails`)
};

const es_nav_emails = /** @type {(inputs: Nav_EmailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correos`)
};

/**
* | output |
* | --- |
* | "Emails" |
*
* @param {Nav_EmailsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_emails = /** @type {((inputs?: Nav_EmailsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_EmailsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_emails(inputs)
	return es_nav_emails(inputs)
});